import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
//--------MODULES
import { CommonModule } from "@angular/common";
import { RouterModule, RouteReuseStrategy, Router } from '@angular/router';
import { AppMaterialModule } from "@root/app-material.module";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { NgxOtpInputModule } from 'ngx-otp-input';
import { IvyCarouselModule } from 'angular-responsive-carousel';

//--------COMPONENTS
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { EnterOtpModalComponent } from './components/enter-otp-modal/enter-otp-modal.component';
import { NavMenuComponent } from '@common/components/nav-menu/nav-menu.component';
import { TransactMenuComponent } from '@common/components/transact-menu/transact-menu.component';
import { AppLoaderComponent } from '@common/components/loader/loader.component';
import { FakeCardLoaderComponent } from '@common/components/fake-card-loader/fake-card-loader.component';
import { FakeTabLoaderComponent } from '@common/components/fake-tab-loader/fake-tab-loader.component';
import { SchemeCardComponent } from '@common/components/scheme-card/scheme-card.component';
import { AmountComponent } from '@common/components/amount/amount.component';
import { TooltipComponent } from '@common/components/tooltip/tooltip.component';
import { UsCanadaModalComponent } from '@common/components/us-canada-modal/us-canada-modal.component';
import { FileDownload } from "@common/components/file-download/file-download.component";
import { AlertComponent } from "@common/components/alert/alert.component";
import { GetIfscModalComponent } from './components/get-ifsc-modal/get-ifsc-modal.component';
import { SubmitTransactModalComponent } from './components/submit-transact-modal/submit-transact-modal.component';
import { UserFeedbackModalComponent } from './components/user-feedback-modal/user-feedback-modal.component';
import { PaymentDisclaimerComponent } from './components/payment-disclaimer/payment-disclaimer.component';
//--------PAGES
import { HomePageComponent } from '@common/pages/home-page/home.page';
//--------TEMPLATES
import { PageTemplateComponent } from './templates/page-template/page-template.component';
import { CardTemplateComponent } from './templates/card-template/card-template.component';
import { ModelTemplateComponent } from './templates/model-template/model-template.component';
import { CardOverviewComponent } from './templates/card-overview/card-overview.component';
//--------DIRECTIVES
import { PanOrEmailValidatorDirective } from "@common/directives/pan-or-email-validator";
import { PasswordValidatorDirective } from "@common/directives/password-validator";
import { PanValidatorDirective } from "@common/directives/pan-validator";
import { PhoneValidatorDirective } from "@common/directives/phone.validator";
import { NumberOnlyDirective } from '@common/directives/number-only.directive';
import { AlphabetsOnlyDirective } from './directives/alphabets-only.directive';
import { AlphabetsNumericOnlyDirective } from './directives/alpha-numeric-only.directive';
import { MinDirective } from './directives/min.directive';
import { AllowCharDirective } from './directives/allow-char.directive';
import { MobileOrEmailValidatorDirective } from './directives/mobile-or-email-validator';

//--------PIPE
import { RedactPipe } from '@common/pipe/redact.pipe';
import { SearchFilter } from '@common/pipe/search-filter.pipe';
import { AmountPipe } from '@common/pipe/amount.pipe';
import { PercentagePipe } from '@common/pipe/percentage.pipe';
import { DatePipe } from "@common/pipe/date.pipe";
import { AmountToWordPipe } from '@root/modules/common/pipe/amount-to-words.pipe';
import { SchemeFilterPipe } from '@common/pipe/scheme-filter.pipe';
//--------SERVICES
import { HttpInterceptorService } from '@common/services/interceptor.service';
import { HeaderService } from '@common/services/header.service';
import { GetIfscService } from './services/get-ifsc.service';
import { UserFeedbackService } from '@common/services/user-feedback.service';
import { EncryptionProviderService } from '@root/modules/common/services/encryption.service';

//--------HANDLERS
import { CommonService } from '@common/services/common.service';
import { DecimalNumberOnlyDirective } from './directives/decimal-number-only.directive';

import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { DATE_FORMATS } from '@common/constants/date-format.constant';
import { SmsRetriever } from '@ionic-native/sms-retriever/ngx';
import { ITDNameValidationModalComponent } from './components/itd-name-validation-modal/itd-name-validation-modal.component';

const httpInterceptorProvider =[
  { provide: HTTP_INTERCEPTORS, useClass:HttpInterceptorService, multi:true, deps:[Router, CommonService, EncryptionProviderService ] }
]
@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    EnterOtpModalComponent,
    NavMenuComponent,
    TransactMenuComponent,
    AppLoaderComponent,
    FakeCardLoaderComponent,
    FakeTabLoaderComponent,
    SchemeCardComponent,
    AmountComponent,
    TooltipComponent,
    UsCanadaModalComponent,
    ITDNameValidationModalComponent,
    FileDownload,
    AlertComponent,
    GetIfscModalComponent,
    SubmitTransactModalComponent,
    UserFeedbackModalComponent,
    PaymentDisclaimerComponent,
    //------TEMPLATES
    PageTemplateComponent,
    CardTemplateComponent,
    ModelTemplateComponent,
    CardOverviewComponent,
    //------PAGES
    HomePageComponent,
    //------DIRECTIVES
    PanOrEmailValidatorDirective,
    PasswordValidatorDirective,
    PanValidatorDirective,
    PhoneValidatorDirective,
    NumberOnlyDirective,
    AlphabetsNumericOnlyDirective,
    AlphabetsOnlyDirective,
    DecimalNumberOnlyDirective,
    AllowCharDirective,
    MinDirective,
    MobileOrEmailValidatorDirective,
    //------PIPES
    RedactPipe,
    SearchFilter,
    AmountPipe,
    AmountToWordPipe,
    PercentagePipe,
    DatePipe,
    SchemeFilterPipe
  ],
  entryComponents: [],
  imports: [
    CommonModule,
    RouterModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule.forRoot(), 
    NgxOtpInputModule,
    IvyCarouselModule,
  ],
  exports:[
    CommonModule,
    RouterModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    NgxOtpInputModule,
    IvyCarouselModule,
    HeaderComponent,
    FooterComponent,
    EnterOtpModalComponent,
    NavMenuComponent,
    TransactMenuComponent,
    AppLoaderComponent,
    FakeCardLoaderComponent,
    FakeTabLoaderComponent,
    SchemeCardComponent,
    AmountComponent,
    TooltipComponent,
    UsCanadaModalComponent,
    ITDNameValidationModalComponent,
    FileDownload,
    AlertComponent,
    GetIfscModalComponent,
    SubmitTransactModalComponent,
    PaymentDisclaimerComponent,
    
    //------TEMPLATES
    PageTemplateComponent,
    CardTemplateComponent,
    ModelTemplateComponent,
    CardOverviewComponent,
    //------PAGES
     HomePageComponent,
    //------DIRECTIVES
    PanOrEmailValidatorDirective,
    PasswordValidatorDirective,
    PanValidatorDirective,
    PhoneValidatorDirective,
    NumberOnlyDirective,
    AlphabetsOnlyDirective,
    AlphabetsNumericOnlyDirective,
    DecimalNumberOnlyDirective,
    AllowCharDirective,
    MinDirective,
    MobileOrEmailValidatorDirective,
    //------PIPES
    RedactPipe,
    SearchFilter,
    SchemeFilterPipe,
    AmountPipe,
    AmountToWordPipe,
    PercentagePipe,  
    DatePipe 
  ],
  providers: [
    httpInterceptorProvider,
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    HeaderService,
    GetIfscService,
    UserFeedbackService,
    SmsRetriever,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS},
  ],
  bootstrap: [],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppCommonModule {}
